import React, { useEffect, useState } from "react";
import Companydetailsform from "../../Forms/Companydetailsform/Companydetailsform";

export default function Companydetails() {

    const [companysumbit, setCompanysubmit] = useState(true)
 

    useEffect(() => {

        window.scrollTo(0, 0);
        

    }, [ ])

    return (
        <>

            {/* Companydetails start */}

            {companysumbit === true ? <div className="company_details">
                <div className="d-flex justify-content-between createaccountpage_content_header_container">
                    <div className="d-flex">
                        <div>
                            <div className="createaccountpage_content_header">
                                Company Details
                            </div>
                            <div className="createaccountpage_content_text">
                                Show details of your business data
                            </div>
                        </div>
                        <div>
                            <button type="button" className="createaccountpage_pending_approval_button">
                                Pending Approval
                            </button>
                            <button type="button" className="createaccountpage_declined_button">
                                Declined
                            </button>
                            <button type="button" className="createaccountpage_approved_button">
                                Approved
                            </button>
                            <button type="button" className="createaccountpage_edit_button" onClick={() => setCompanysubmit(false)}>
                                Edit
                            </button>
                        </div>
                    </div>
                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#businessinfo" aria-expanded="true" aria-controls="businessinfo">
                        Business Information
                    </button>
                    <div id="businessinfo" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">

                        <table className="createaccountpage_content_table">
                            <tbody>
                                <tr>
                                    <td>Type of Business</td>
                                    <td className="m-0">
                                        <button type="button">
                                            Online Retailer
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Website</td>
                                    <td>thebooks.com.au</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#sellto" aria-expanded="true" aria-controls="sellto">
                        Sell to
                    </button>
                    <div id="sellto" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">

                        <table className="createaccountpage_content_table">

                            <tbody>
                                <tr>
                                    <td>Business Name</td>
                                    <td>The Good Bookstore</td>
                                </tr>
                                <tr>
                                    <td>Address 1</td>
                                    <td>371 Alexandra Road #06-19 AIA Building</td>
                                </tr>
                                <tr>
                                    <td>Address 2</td>
                                    <td>3 Sungei Kadut Crescent</td>
                                </tr>

                                <tr>
                                    <td>City</td>
                                    <td>Singapore</td>

                                    <td>State</td>
                                    <td>Singapore</td>
                                    <td>Country</td>
                                    <td>Singapore</td>
                                </tr>
                                <tr>
                                    <td>Postal Code</td>
                                    <td>728686</td>
                                </tr>
                                <tr>
                                    <td>Phone</td>
                                    <td>63620721</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> : <Companydetailsform />}

            {/* Companydetails over */}

        </>
    )

}